import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import TopBar from '../bars/top-bar'
// import IconButton from '../buttons/icon-button'
// import SaveIconButton from '../buttons/SaveIconButton'
import ImgCover from '../utilities/img-cover'
import HeadingLabel from '../headings/heading-label'
import HeadingDelta from '../headings/heading-delta'
import SmallText from '../texts/small-text'
import Indicator from '../texts/indicator'
import InfoBlock from '../texts/info-block'
import InfoText from '../texts/info-text'
import InfoExpanders from '../lists/info-expanders'
import InfoExpandersItem from '../lists/info-expanders-item'
import LinkAnchor from '../links/link-anchor'
// import ActionBoxAuction from '../boxes/action-box-auction'
import ActionBoxButton from '../boxes/action-box-button'
import MapBox from '../../ui/maps/map-box'
import MoreInfoBlock from '../texts/more-info-block'
import AuctionStateTag from '../tags/auction-state-tag'
import BackIconButton from '../buttons/BackIconButton'
import values from 'lodash/values'
import SelectModal from '../../services/modal/SelectModal'
import { AUCTION_DETAIL_MODAL_TYPE } from '../../services/auction/constants'

const createTopBarLeftChildren = props => {
  const { auction, showStateTag } = props
  const leftChildren = [<BackIconButton key='backIconButton' />]
  // if (showSaveIcon)
  //   leftChildren.push(
  //     <SaveIconButton isSaved={isAuctionSaved} key='saveIconButton' />
  //   )
  if (showStateTag)
    leftChildren.push(
      <AuctionStateTag auctionState={auction.state} key='stateTag' />
    )
  return leftChildren
}

const renderActionBox = (props, type) => {
  const {
    // isAuctionSaved,
    isAuctionLive,
    linkToItems,
    // translations
    haveGreatItemsText,
    takeLookText,
    viewItemsText
    // savedText,
    // saveEventText
  } = props
  const className = type === 'mobile' ? 'fixed-bottom' : ''
  const mediaQuery =
    type === 'mobile' ? '(max-width: 1023px)' : '(min-width: 1024px)'
  return isAuctionLive ? (
    <MediaQuery query={mediaQuery}>
      <ActionBoxButton
        className={className}
        iconName='auction-products'
        label={haveGreatItemsText}
        text={takeLookText}
        onClick={linkToItems}
      />
    </MediaQuery>
  ) : (
    <MediaQuery query={mediaQuery}>
      <ActionBoxButton
        className={className}
        iconName='auction-products'
        text={viewItemsText}
        onClick={linkToItems}
      />
    </MediaQuery>
    // <MediaQuery query={mediaQuery}>
    //   <ActionBoxAuction
    //     className={className}
    //     isSaved={isAuctionSaved}
    //     leftText={viewItemsText}
    //     onClickLeft={linkToItems}
    //     rightText={isAuctionSaved ? savedText : saveEventText}
    //   />
    // </MediaQuery>
  )
}

const AuctionDetail = props => {
  const {
    auction,
    charityName,
    charityUrl,
    eventDateFormatted,
    startDateFormatted,
    closeDateFormatted,
    isAuctionClosed,
    isModalOpen,
    modalType,
    closeModal,
    openSchedule,
    openHowToAttend,
    openQuestions,
    itemsLink,
    // translations
    startText,
    closeText,
    // shareText,
    locationText,
    viewMapText,
    charityText,
    descriptionText,
    scheduleEventText,
    auctionItemsText,
    howToAttendEventText,
    askQuestionText
  } = props

  return (
    <div>
      <TopBar
        theme='light-bar'
        leftChildren={createTopBarLeftChildren(props)}
        rightChildren={
          [
            // <IconButton iconName='share' text={shareText} key='shareIcon' />
          ]
        }
      />
      {!isAuctionClosed && renderActionBox(props, 'desktop')}
      <div className='detail-item'>
        {auction.photo && (
          <div className='detail-image'>
            <ImgCover src={auction.photo} alt={'auction'} />
          </div>
        )}
        <div className='detail-info'>
          <div className='detail-section desk-half'>
            <HeadingLabel labelText='' titleText={auction.title} />
            <SmallText light>{eventDateFormatted}</SmallText>
            <Indicator
              className='shy-indicator'
              labelText={startText}
              titleText={startDateFormatted}
            />
            <Indicator
              shyLabel
              className='shy-indicator'
              labelText={closeText}
              titleText={closeDateFormatted}
            />
            <Indicator
              className='shy-indicator'
              labelText={locationText}
              titleText={auction.location}
            >
              <LinkAnchor
                iconName='map-pin'
                text={viewMapText}
                linkTo='#map-box'
              />
            </Indicator>
            <Indicator
              className='shy-indicator'
              labelText={charityText}
              titleText={charityName}
              url={charityUrl}
            />
          </div>
          <div className='detail-section'>
            <InfoBlock>
              <HeadingDelta>{descriptionText}</HeadingDelta>
              <MoreInfoBlock limitLines={5} text={auction.description} />
            </InfoBlock>
          </div>
          <InfoExpanders>
            <InfoExpandersItem href='#' onClick={openSchedule} iconName='clock'>
              {scheduleEventText}
            </InfoExpandersItem>
            {!isAuctionClosed &&
              itemsLink && (
                <InfoExpandersItem href={itemsLink} iconName='auction-products'>
                  {auctionItemsText}
                </InfoExpandersItem>
              )}
            {!isAuctionClosed && (
              <InfoExpandersItem
                href='#'
                onClick={openHowToAttend}
                iconName='info'
              >
                {howToAttendEventText}
              </InfoExpandersItem>
            )}
            {!isAuctionClosed && (
              <InfoExpandersItem
                href='#'
                onClick={openQuestions}
                iconName='question'
              >
                {askQuestionText}
              </InfoExpandersItem>
            )}
          </InfoExpanders>
          <div className='detail-section'>
            <InfoBlock>
              <HeadingDelta>{locationText}</HeadingDelta>
              <InfoText iconName='map-pin'>
                <p>{auction.location}</p>
              </InfoText>
            </InfoBlock>
            {auction.lat &&
              auction.lng && (
                <MapBox
                  lat={auction.lat}
                  lng={auction.lng}
                  containerElement={<div className='map-box' id='map-box' />}
                  mapElement={<div style={{ height: '100%' }} />}
                />
              )}
          </div>
        </div>
      </div>
      {!isAuctionClosed && renderActionBox(props, 'mobile')}
      {isModalOpen && (
        <SelectModal onClose={closeModal} modalType={modalType} />
      )}
    </div>
  )
}

AuctionDetail.propTypes = {
  auction: PropTypes.object,
  charityName: PropTypes.string.isRequired,
  charityUrl: PropTypes.string,
  eventDateFormatted: PropTypes.string.isRequired,
  startDateFormatted: PropTypes.string.isRequired,
  closeDateFormatted: PropTypes.string.isRequired,
  showStateTag: PropTypes.bool.isRequired,
  showSaveIcon: PropTypes.bool.isRequired,
  isAuctionSaved: PropTypes.bool.isRequired,
  isAuctionLive: PropTypes.bool.isRequired,
  isAuctionClosed: PropTypes.bool.isRequired,
  isAuctionPending: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool,
  modalType: PropTypes.oneOf(values(AUCTION_DETAIL_MODAL_TYPE)),
  closeModal: PropTypes.func,
  openSchedule: PropTypes.func,
  openHowToAttend: PropTypes.func,
  openQuestions: PropTypes.func,
  itemsLink: PropTypes.string,
  linkToItems: PropTypes.func,
  // translations
  startText: PropTypes.string.isRequired,
  closeText: PropTypes.string.isRequired,
  locationText: PropTypes.string.isRequired,
  viewMapText: PropTypes.string.isRequired,
  charityText: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  viewItemsText: PropTypes.string.isRequired,
  saveEventText: PropTypes.string.isRequired,
  savedText: PropTypes.string.isRequired,
  shareText: PropTypes.string.isRequired,
  haveGreatItemsText: PropTypes.string.isRequired,
  takeLookText: PropTypes.string.isRequired,
  scheduleEventText: PropTypes.string.isRequired,
  auctionItemsText: PropTypes.string.isRequired,
  howToAttendEventText: PropTypes.string.isRequired,
  askQuestionText: PropTypes.string.isRequired
}

export default AuctionDetail



// WEBPACK FOOTER //
// ./src/ui/views/auction-detail.js